import Dropdown from '@common/components/dropdown';
import { useTranslation } from '@common/hooks/translation';
import React from 'react';
import Config from '@skin_config';
import PropTypes from 'prop-types';
import './style.scss';

export const CurrencyFields = ({
  value, onChange, errorMessage,
}) => {
  const t = useTranslation();
  const currencyNames = new Set([...Config.main.availableCurrencies]);

  return (
    <div className="currency-field">
      <div className="popup-txt">
        {t('Currency')}
      </div>
      <Dropdown
        className="currency-field-select"
        value={value?.name}
        onChange={(option) => onChange({
          ...value,
          name: option.value,
        })}
        options={[...currencyNames].map((currency) => ({
          value: currency,
          name: currency,
        })) || []}
      />
      {!!errorMessage && <div className="error-message">{t(errorMessage)}</div>}
    </div>
  );
};

CurrencyFields.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
};
